import { render, staticRenderFns } from "./SchoolDropdownItem.vue?vue&type=template&id=71677b15&scoped=true&"
import script from "./SchoolDropdownItem.vue?vue&type=script&lang=js&"
export * from "./SchoolDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71677b15",
  null
  
)

export default component.exports